// extracted by mini-css-extract-plugin
export var container = "Switch-module--container--aoJKe";
export var slider = "Switch-module--slider--PhqbI";